module.exports = __webpack_public_path__ + "static/media/iconPost.91dd1201.svg";